import FundTable from '../component/employee/fund/FundTable';

export default function AllAccBalance() {
  return (
    <div className="p-4">
      <FundTable />
    </div>
  );
}
